import React, { useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';

import './DeletePlayerModal.scss';

const DeletePlayerModal = ({ deletePlayerHandler, handleCloseModal, showModal }) => {
  const handleKeyDown = useCallback(
    e => {
      if (e.key === 'Escape') handleCloseModal();
    },
    [handleCloseModal],
  );

  useEffect(() => {
    if (showModal) {
      document.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [showModal, handleKeyDown]);

  if (!showModal) return null;

  return ReactDOM.createPortal(
    <div className="delete-modal-overlay" onClick={handleCloseModal}>
      <div className="delete-modal" onClick={e => e.stopPropagation()}>
        {/* Icon */}
        <div className="delete-modal__icon">
          <i className="fas fa-exclamation-triangle" />
        </div>

        {/* Content */}
        <h3 className="delete-modal__title">Delete Player</h3>
        <p className="delete-modal__text">
          Kajtuniu, are you sure you want to delete this player? This action cannot be undone.
        </p>

        {/* Actions */}
        <div className="delete-modal__actions">
          <button
            type="button"
            className="delete-modal__btn delete-modal__btn--cancel"
            onClick={handleCloseModal}
          >
            Cancel
          </button>
          <button
            type="button"
            className="delete-modal__btn delete-modal__btn--delete"
            onClick={() => {
              deletePlayerHandler();
              handleCloseModal();
            }}
          >
            <i className="fas fa-trash-alt" /> Delete
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default DeletePlayerModal;
